// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// FRONT-END-ONLY SEED DATA (header weather widget). Shaped after the mockup's
// weather popover (Helios Bindings.dc.html, ~line 177). Days are generated
// relative to "today" so the first row always reads "Today" regardless of when
// it renders. In future this should come from the BFF weather relay rather
// than hardcoded — see docs/design/hardcoded-frontend-data.md.

import type { WeatherCondition, WeatherForecast } from '../types/weather';

interface DayShape {
  condition: WeatherCondition;
  min: number;
  max: number;
}

// Six-day pattern matching the design's popover (°F).
const PATTERN: DayShape[] = [
  { condition: 'sun', min: 74, max: 96 },
  { condition: 'sun', min: 73, max: 93 },
  { condition: 'cloud', min: 75, max: 89 },
  { condition: 'rain', min: 72, max: 85 },
  { condition: 'cloud', min: 71, max: 88 },
  { condition: 'sun', min: 73, max: 90 },
];

/** Local midnight `offset` days from today. */
function dayFromToday(offset: number): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
}

/** Build the seeded header forecast, anchored to the current date. */
export function MOCK_HEADER_FORECAST(): WeatherForecast {
  return {
    current: 94,
    unitSuffix: '°F',
    days: PATTERN.map((d, i) => ({
      date: dayFromToday(i),
      condition: d.condition,
      min: d.min,
      max: d.max,
    })),
  };
}
